import React, { useContext } from "react"
import { ResponsiveBar } from '@nivo/bar'
import { ThemeContext } from '../../contexts/themeContext'

const MyResponsiveBar = ({ object }) => {
    const { theme } = useContext(ThemeContext)
    const { chosenFontSize } = theme
    const { src, content } = object

    const barTheme = {
        axis: {
            legend: {
                text: {
                    fontSize: chosenFontSize,
                    fontWeight: "bold",
                    fill: "#536681",
                    fontFamily: "\"Open Sans\", sans-serif"
                }
            }
        }
    }

    return (
        <>
            <div style={{ height: 300 }}>
                <ResponsiveBar
                    data={content.data}
                    keys={content.keys}
                    indexBy={content.index}
                    margin={{ top: 15, right: 15, bottom: 70, left: 60 }}
                    padding={0.35}
                    theme={barTheme}
                    colors={{ scheme: 'nivo' }}
                    borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: content.values[0],
                        legendPosition: 'middle',
                        legendOffset: 40,
                        fontWeight: "bold"
                    }}
                    axisLeft={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: content.values[1],
                        legendPosition: 'middle',
                        legendOffset: -45
                    }}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                    animate={true}
                    motionStiffness={90}
                    motionDamping={15}
                />
            </div>
            {src && <p className='src-legend p-0'><a href={src} target='_blank' rel="noopener noreferrer">fonte: {src}</a></p>}
        </>
    )
}

export default MyResponsiveBar